import { render, staticRenderFns } from "./FilterCourseUnit.vue?vue&type=template&id=5592843e&scoped=true&"
import script from "./FilterCourseUnit.vue?vue&type=script&lang=js&"
export * from "./FilterCourseUnit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5592843e",
  null
  
)

export default component.exports